import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../../apis/UsersApi';
import { jwtDecode } from 'jwt-decode';

const Login = ({ toggleView }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [login, { isLoading, error }] = useLoginMutation();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await login({ email, password }).unwrap();
            const { accessToken, refreshToken, userData } = response;

            const decodedToken = jwtDecode(accessToken);
            if (!decodedToken || decodedToken.exp < Date.now() / 1000) {
                throw new Error("Invalid or expired token");
            }

            localStorage.setItem("jwt", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("userData", JSON.stringify(userData));

           // console.log("User logged in:", userData);
            navigate("/");
        } catch (err) {
          //  console.error("Login failed:", err.message);
        }
    }

    return (
        <div className="col-xl-6 pe-xl-5">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                  {/* Add the logo image here */}
            <div className="mb-16 flex-center">
            <img 
        src={`${process.env.PUBLIC_URL}/assets/images/logo/logoOld.png`} 
        alt="Logo" 
        className="img-fluid" 
        style={{ width: '100px', height: 'auto' }} // Adjust width as needed
    />
            </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-24">
                        <label
                            htmlFor="username"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Email <span className="text-danger">*</span>
                        </label>
                        <input
                            type="email"
                            className="common-input"
                            id="username"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="mb-24">
                        <label
                            htmlFor="password"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Password
                        </label>
                        <div className="position-relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="common-input"
                                id="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                                className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${
                                    showPassword ? 'ph-eye' : 'ph-eye-slash'
                                }`}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                    </div>
                    <div className="mb-24 mt-48">
                        <button 
                            type="submit" 
                            className="btn btn-main py-18 px-40" 
                            disabled={isLoading}
                        >
                            {isLoading ? "Logging in..." : "Login"}
                        </button>
                        {error && <p className="text-danger mt-2">Login failed. Please try again.</p>}
                     {/*
                       <div className="mt-24">
                            <Link
                                to="#"
                                className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                            >
                                Forgot your password?
                            </Link>
                        </div> */}
                    </div>
                    <div className="mt-24">
                        <p className="text-sm">
                            Don't have an account?{' '}
                            <button
                                type="button"
                                onClick={toggleView}
                                className="text-main-600 text-decoration-underline bg-transparent border-0 cursor-pointer"
                            >
                                Register here
                            </button>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;